var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./phone.css";
import { Link } from "react-router-dom";
/** <b>Composant en mode consultation/detail d'un champ de type phone</b>*/
export default function PhoneFieldDetail(_a) {
    var fieldName = _a.fieldName, record = _a.record;
    var value = useMemo(function () {
        var r = record || {};
        return fieldName && r[fieldName];
    }, [record, fieldName]);
    var buttonStyle = {
        border: "none",
        background: "none",
    };
    var handleClick = function () {
        //Déclenche un appel téléphonique
        window.location.href = "tel:".concat(value);
    };
    return (_jsx(_Fragment, { children: value && (_jsx(Link, __assign({ to: "tel:".concat(value), onClick: handleClick }, { children: _jsx(PhoneInput, { country: "fr", value: value, inputProps: {
                    readOnly: true,
                }, disableDropdown: true, buttonStyle: buttonStyle, inputStyle: {
                    border: "none",
                    background: "none",
                    paddingLeft: "30px",
                    color: "var(--colors-label)",
                } }) }))) }));
}
